import {ContentBlock, Icon} from "@gplibraries/react/components";
import {Link} from "react-router";
import {DealerAccessAuthorizer} from "@gplibraries/utils";

interface TmInfoBlockProps {
  user: DealerAccessAuthorizer
}

export default function ContentManagementBlock({ user }: TmInfoBlockProps) {

  return (
    <ContentBlock title={'Content Management'} icon={<Icon glyph={'folder2-open'}/>}>
      <h3>Add/Edit Content</h3>

      <ul className={'content-edit-links'}>
        {(user.hasRole('announcements_editor') || user.hasRole('power_user')) &&
          <li><Link to={'/content/alerts'} reloadDocument>Alerts</Link></li>
        }
        {(user.hasRole('announcements_editor')|| user.hasRole('power_user')) &&
          <li><Link to={'/content/announcements'} reloadDocument>Announcements</Link></li>
        }
        <li><Link to={'/content/articles'} reloadDocument>Articles</Link></li>
        {(user.hasRole('bargain_warehouse_editor')|| user.hasRole('power_user')) &&
          <li><Link to={'/content/bargain-warehouse'} reloadDocument>Bargain Warehouse</Link></li>
        }
        {(user.hasRole('bargain_warehouse_parts_editor')|| user.hasRole('power_user')) &&
          <li><Link to={'/content/parts-bargain-warehouse'} reloadDocument>Bargain Warehouse - Parts</Link></li>
        }
        {(user.hasRole('bulletins_editor')|| user.hasRole('power_user')) &&
          <li><Link to={'/content/bulletins'} reloadDocument>Bulletins</Link></li>
        }
        <li><Link to={'/content/dealer-resource-links'} reloadDocument>Dealer Resource Links</Link></li>
        {(user.hasRole('service_documents_editor')|| user.hasRole('power_user')) &&
          <li><Link to={'/content/technical-information-bulletins'} reloadDocument>Technical Information Bulletins</Link></li>
        }
        {(user.hasRole('service_documents_editor')|| user.hasRole('power_user')) &&
          <li><Link to={'/content/technical-information-manuals'} reloadDocument>Technical Information Manuals</Link></li>
        }
        {(user.hasRole('tm_resource_editor')|| user.hasRole('power_user')) &&
          <li><Link to={'/content/tm-resource-links'} reloadDocument>TM Resource Links</Link></li>
        }
        {(user.hasRole('webform_administrator')|| user.hasRole('power_user')) &&
          <li><Link to={'/content/admin/webform'} reloadDocument>Webforms</Link></li>
        }
      </ul>
      {(user.hasRole('power_user') || user.isAdmin()) && <>
      <h3>Admins Only</h3>
      <ul className={'no-marker content-edit-links'}>
          <li><Link to={'/categories/edit'}>Edit Dealer/TM Link Subcategories</Link></li>
      </ul>
      </>}
    </ContentBlock>
  );
}